(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section-main-collection-grid"] && !Shopify.designMode) return;
  try {
    const grid = document.querySelector('.custom-products-grid');
  const viewport = document.querySelector('.custom-products-wrapper');
  const cards = grid.children;

  const leftArrows = document.querySelectorAll('.arrow-left');
  const rightArrows = document.querySelectorAll('.arrow-right');

  let index = 0;
  const total = cards.length;

  const cardWidth = cards[0].offsetWidth;
  const gap = parseFloat(getComputedStyle(grid).gap) || 0;
  const step = cardWidth + gap;

  function getVisibleCards() {
    return Math.floor((viewport.offsetWidth + gap) / step);
  }

  function getMaxIndex() {
    return Math.max(0, total - getVisibleCards());
  }

  function update() {
    grid.scrollTo({
      left: index * step,
      behavior: 'smooth',
    });

    const maxIndex = getMaxIndex();

    leftArrows.forEach((btn) => (btn.disabled = index === 0));
    rightArrows.forEach((btn) => (btn.disabled = index >= maxIndex));
  }

  rightArrows.forEach((btn) => {
    btn.onclick = () => {
      const maxIndex = getMaxIndex();
      if (index < maxIndex) {
        index++;
        update();
      }
    };
  });

  leftArrows.forEach((btn) => {
    btn.onclick = () => {
      if (index > 0) {
        index--;
        update();
      }
    };
  });

  grid.addEventListener('scroll', () => {
    const newIndex = Math.round(grid.scrollLeft / step);
    const maxIndex = getMaxIndex();

    index = Math.min(newIndex, maxIndex);

    leftArrows.forEach((btn) => (btn.disabled = index === 0));
    rightArrows.forEach((btn) => (btn.disabled = index >= maxIndex));
  });

  window.addEventListener('resize', update);

  update();
  } catch(e) { console.error(e); }
})();

})();
